import type { EditorCapabilities } from "../types";

/** Capabilities every preset builds on top of. */
export const DefaultCapabilities: EditorCapabilities = {
  heading: { levels: [1, 2] },
};

export default DefaultCapabilities;
